import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { theme } from '@app/helpers';
import { DotLoader } from '@app/components';

const useStyles = makeStyles({
    root: {
        minWidth: (props: any) => (props.minWidth !== undefined ? props.minWidth : 0),
        borderRadius: 4,
        border: 0,
        padding: '0 16px',
        boxShadow: 'none',
        height: '32px',
        '&:hover': {
            boxShadow: 'none'
        },
        '&.MuiButton-outlined': {
            border: `1px solid ${theme.input.border.default}`,
            background: theme.grayPalette.weight100,
            color: theme.inputLabel.color,
            '&.Mui-disabled': {
                borderColor: '#E5E5E5',
                color: '#ABABAB'
            },
            '&:hover': {
                background: theme.palette.action.hover
            }
        }
    },
    label: {
        fontFamily: `'Roboto', 'IBM Plex Sans', 'sans-serif'`,
        fontSize: 14,
        lineHeight: 1.3,
        textTransform: 'none'
    },
    containedPrimary: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:link': {
            color: 'white'
        },
        '&:hover': {
            background: 'rgb(0, 81, 132)'
        }
    },
    containedSecondary: {
        background: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText
    },
    text: {
        background: 'transparent',
        color: theme.palette.primary.main,
        padding: '4px 5px'
    },
    tertiaryCTA: {
        background: 'transparent',
        color: '#166EFA',
        fontSize: 12,
        lineHeight: 16,
        '&:hover': {
            background: '#BBD5FE'
        },
        '&:active': {
            background: '#8EB8FD',
        },
        '&:disabled': {
            background: 'transparent',
            color: '#8EB8FD',
        }
    },
    tertiary: {
        background: 'transparent',
        color: '#001D30',
        fontSize: 14,
        lineHeight: 22,
        padding: '5px 12px',
        '&:hover': {
            background: '#E5E5E5'
        },
        '&:active': {
            background: '#DCDFE4',
        },
        '&:disabled': {
            background: 'transparent',
            color: '#A5ADB7',
        }
    }
});

export const PasslyButton = (props: any) => {
    const { isLoading, additionalColor, className, ...rest } = props;
    const classes = useStyles(props);

    const buttonClasses = {
        root: classes.root,
        label: classes.label,
        containedPrimary: classes.containedPrimary,
        containedSecondary: classes.containedSecondary,
        text: classes.text,
    };

    let additionalClass = '';

    if (additionalColor === 'tertiary') {
        additionalClass = classes.tertiary;
    } else if (additionalColor === 'tertiaryCTA') {
        additionalClass = classes.tertiaryCTA;
    }

    return (
        <Button
            className={`${additionalClass} ${className}`}
            classes={buttonClasses}
            disableFocusRipple={true}
            {...rest}
        >
            {isLoading ? <DotLoader dark={false} /> : props.children}
        </Button>
    );
};
